module.exports = __webpack_public_path__ + "assets/images/circunference_r.c4e6fbbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/circunference_r.png
// module id = 689
// module chunks = 1